<div class="modal-header {{ dialogClass }}">
  <h4 class="modal-title float-left">{{ title }}</h4>
</div>
<div class="modal-body" innerHTML="{{ message }}"></div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" *ngIf="showYesNo" (click)="yesClick()">{{ yesButtonText }}</button>
  <button type="button" class="btn btn-primary" *ngIf="showYesNo" (click)="noClick()">{{ noButtonText }}</button>
  <button type="button" class="btn btn-default" *ngIf="showOK" (click)="okClick()">{{ okButtonText }}</button>
</div>
